export class ManisfestacaoConselhoFsical {

    static manisfestacaoConselhoFsicalLista: ManisfestacaoConselhoFsical[] = [
        { tipo: 'pdf', descricao: '2º Semestre de 2023', caminho: 'manifestacao_conselho_fiscal_22023.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2023', caminho: 'manifestacao_conselho_fiscal_12023.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2022', caminho: 'manifestacao_conselho_fiscal_22022.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2022', caminho: 'manifestacao_conselho_fiscal_12022.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2021', caminho: 'manifestacao_conselho_fiscal_22021.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2021', caminho: 'manifestacao_conselho_fiscal_12021.pdf' },
        //{ tipo: 'pdf', descricao: '1º Semestre de 2021', caminho: 'manifestacao_conselho_fiscal_com_RCIs_1semestre2021.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2020', caminho: 'manifestacao_conselho_fiscal_22020.pdf' },
        //{ tipo: 'pdf', descricao: '2º Semestre de 2020', caminho: 'manifestacao_conselho_fiscal_com_RCIs_2semestre2020.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2020', caminho: 'manifestacao_conselho_fiscal_12020.pdf' },
        //{ tipo: 'pdf', descricao: '1º Semestre de 2020', caminho: 'manifestacao_conselho_fiscal_com_RCIs_1semestre2020.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2019', caminho: 'manifestacao_conselho_fiscal_12019.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2019', caminho: 'manifestacao_conselho_fiscal_22019.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2018', caminho: 'manifestacao_conselho_fiscal_12018.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2018', caminho: 'manifestacao_conselho_fiscal_22018.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2017', caminho: 'manifestacao_conselho_fiscal_12017.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2017', caminho: 'manifestacao_conselho_fiscal_22017.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2016', caminho: 'manifestacao_conselho_fiscal_12016.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2016', caminho: 'manifestacao_conselho_fiscal_22016.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2015', caminho: 'manifestacao_conselho_fiscal_12015.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2015', caminho: 'manifestacao_conselho_fiscal_22015.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2014', caminho: 'manifestacao_conselho_fiscal_12014.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2014', caminho: 'manifestacao_conselho_fiscal_22014.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2013', caminho: 'manifestacao_conselho_fiscal_12013.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2013', caminho: 'manifestacao_conselho_fiscal_22013.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2012', caminho: 'manifestacao_conselho_fiscal_12012.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2012', caminho: 'manifestacao_conselho_fiscal_22012.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2011', caminho: 'manifestacao_conselho_fiscal_12011.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2011', caminho: 'manifestacao_conselho_fiscal_22011.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2010', caminho: 'manifestacao_conselho_fiscal_12010.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2010', caminho: 'manifestacao_conselho_fiscal_22010.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2009', caminho: 'manifestacao_conselho_fiscal_12009.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2009', caminho: 'manifestacao_conselho_fiscal_22009.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2008', caminho: 'manifestacao_conselho_fiscal_12008.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2008', caminho: 'manifestacao_conselho_fiscal_22008.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2007', caminho: 'manifestacao_conselho_fiscal_12007.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2007', caminho: 'manifestacao_conselho_fiscal_22007.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2006', caminho: 'manifestacao_conselho_fiscal_12006.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2006', caminho: 'manifestacao_conselho_fiscal_22006.pdf' },
        { tipo: 'pdf', descricao: '1º Semestre de 2005', caminho: 'manifestacao_conselho_fiscal_12005.pdf' },
        { tipo: 'pdf', descricao: '2º Semestre de 2005', caminho: 'manifestacao_conselho_fiscal_22005.pdf' },
        { tipo: 'site', descricao: '1º Semestre de 2004', caminho: 'manifestacao_conselho_fiscal_12004.htm' },
        { tipo: 'site', descricao: '2º Semestre de 2004', caminho: 'manifestacao_conselho_fiscal_22004.htm' },
    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/manifestacao-conselho-fiscal.ts